import { createActions } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions({
    requestDeleteOffer: ['id'],
    deleteOfferSucceeded: ['id'],
    deleteOfferFailed: ['error'],
});

const removeSelectedItem = (items, deletedItemId, identityKey = 'offer_id') =>
    items.filter((item) => item[identityKey] !== deletedItemId);

export default {
    [types.REQUEST_DELETE_OFFER]: (state, { id }) => ({
        ...state,
        delete: {
            ...state.delete,
            id,
            loading: true,
            error: null,
        },
    }),
    [types.DELETE_OFFER_SUCCEEDED]: (state, { id }) => ({
        ...state,
        data: removeSelectedItem(state.data, id),
        delete: {
            ...state.delete,
            id: null,
            loading: false,
        },
    }),
    [types.DELETE_OFFER_FAILED]: (state, { error }) => ({
        ...state,
        delete: {
            ...state.delete,
            id: null,
            loading: false,
            error,
        },
    }),
};
